import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import ExternalDataDetailsView from '../../PartialViews/ExternalData/ExternalDataViews/ExternalDataDetailsView'

export interface IExternalDataSearchByCreditNumberPageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore: ExternalDataStore
    notificationsStore: NotificationsStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')

@observer
class ExternalDataSearchByCreditNumberPage
    extends React.Component<IExternalDataSearchByCreditNumberPageProps> {

    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        const creditNumber = this.props['match']!['params']['creditNumber']
        if (creditNumber) {
            this.props.httpActionsService!.getExternalDataByCreditNumber(creditNumber)
        } else {
            this.props.notificationsStore
                .addAlert(
                    new NotificationEntity(
                        'danger',
                        this.props.localizationStore!.t('no credit number in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, localizationStore } = this.props

        if (externalDataStore!.isError) {
            return (<div>{localizationStore!.t('No data text')}</div>)
        }

        return (
            <div className="external-data-page">
                {
                    !!externalDataStore!.getData && externalDataStore!.getData!.creditInfoItems.length ?
                        <ExternalDataDetailsView externalCreditData={externalDataStore!.getData!.creditInfoItems[0]} />
                        :
                        localizationStore!.t('No data text')
                }
                {/* {!!externalDataStore!.getData
                    && externalDataStore!.getData!.creditInfoItems.length
                    ?
                    <ExternalDataCreditNumberItemsView
                        creditInfoItems={externalDataStore!.getData!.creditInfoItems}
                    />
                    :
                    localizationStore!.t('No data text')} */}
            </div>
        )
    }
}

export default withRouter(ExternalDataSearchByCreditNumberPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataSearchByCreditNumberPage.tsx